import { MapItem } from '@capturum/ui/api';

export interface ApiListResult {
  data: any[];
}

export function apiListResultToMapItem(
  result: ApiListResult,
  valueProperty: string = 'value',
  labelProperty: string = 'label'
): MapItem[] {
  return result.data.map((item) => {
    return {
      label: item[labelProperty],
      value: item[valueProperty],
    };
  });
}
